export function getFullTime1 (a) {
  if (!a) {
    return ''
  }
  const date = new Date(a)
  const Y = date.getFullYear() + '-'
  const M = ((date.getMonth() + 1) < 10 ? ('0' + (date.getMonth() + 1)) : (date.getMonth() + 1)) + '-'
  const D = (date.getDate() < 10 ? ('0' + date.getDate()) : date.getDate())
  const h = (date.getHours() < 10 ? ('0' + date.getMonth()) : date.getMonth()) + ':'
  const m = (date.getMinutes() < 10 ? ('0' + date.getMinutes()) : date.getMinutes())
  // const s = (date.getSeconds() < 10 ? ('0' + date.getSeconds()) : date.getSeconds())
  return Y + M + D + ' ' + h + m
}

export function getFullTime2 (a) {
  if (!a) {
    return ''
  }
  const date = new Date(a)
  // const Y = date.getFullYear() + '-'
  const M = ((date.getMonth() + 1) < 10 ? ('0' + (date.getMonth() + 1)) : (date.getMonth() + 1)) + '月'
  const D = (date.getDate() < 10 ? ('0' + date.getDate()) : date.getDate()) + '日'
  const h = (date.getHours() < 10 ? ('0' + date.getMonth()) : date.getMonth()) + ':'
  const m = (date.getMinutes() < 10 ? ('0' + date.getMinutes()) : date.getMinutes())
  // const s = (date.getSeconds() < 10 ? ('0' + date.getSeconds()) : date.getSeconds())
  return M + D + ' ' + h + m
}

export function getFullTime (a) {
  if (!a) {
    return ''
  }
  const date = new Date(a)
  const Y = date.getFullYear() + '-'
  const M = ((date.getMonth() + 1) < 10 ? ('0' + (date.getMonth() + 1)) : (date.getMonth() + 1)) + '-'
  const D = (date.getDate() < 10 ? ('0' + date.getDate()) : date.getDate())
  const h = (date.getHours() < 10 ? ('0' + date.getMonth()) : date.getMonth()) + ':'
  const m = (date.getMinutes() < 10 ? ('0' + date.getMinutes()) : date.getMinutes()) + ':'
  const s = (date.getSeconds() < 10 ? ('0' + date.getSeconds()) : date.getSeconds())
  return Y + M + D + ' ' + h + m + s
}

export function getTruckMode (a) {
  let str = ''
  switch (a) {
    case 0:
      str = '顺路'
      break
    case 1:
      str = '直发'
      break
    case 2:
      str = '直发'
      break
    default:
      str = '顺路'
  }
  return str
}

export function getMoney (num) {
  const momey = num / 100
  let result = parseFloat(momey)
  if (isNaN(result)) {
    return 0
  }
  result = Math.round(momey * 100) / 100
  let sX = result.toString()
  let posDecimal = sX.indexOf('.')
  if (posDecimal < 0) {
    posDecimal = sX.length
    sX += '.'
  }
  while (sX.length <= posDecimal + 2) {
    sX += '0'
  }
  return sX
}

export function getState (type) {
  /* 订单状态：
 1已下单，未支付保证金
 2待接单
 3司机到达出发地
 4装车未完成
 5确认出发
 6支付完成
 7司机到达目的地
 10司机已接单
待发单
下单中，未支付保证前显示
待接单
还未接单前显示
已接单
司机接单后显示
待出发
司机点击到达出发地后显示
待支付
待支付运费
运送中
途中状态显示
待评价
师傅点击确认收车后显示，客户未评价
已完成
3天未评价默认好评完成订单
已取消
取消订单
 */
  let str = ''
  switch (type) {
    case 1:
      str = '待发单'
      break
    case 2:
      str = '待接单'
      break
    case 3:
      str = '待出发'
      break
    case 4:
      str = '待出发'
      break
    case 5:
      str = '待支付'
      break
    case 6:
      str = '运送中'
      break
    case 7:
      str = '运送中'
      break
    case 8:
      str = '待评价'
      break
    case 9:
      str = '已完成'
      break
    case 10:
      str = '已接单'
      break
    case 21:
      str = '订单取消'
      break
    case 22:
      str = '订单取消'
      break
    case 23:
      str = '订单取消'
      break
    default:
      str = '未知'
  }
  return str
}

export function getPlatformtruckType (a) {
  let b = '未知'
  switch (a) {
    case 1:
      b = '斜板车'
      break
    case 2:
      b = '落地板车'
      break
    case 3:
      b = '5吨板车'
      break
    case 4:
      b = '箱式板车'
      break
  }
  return b
}

export function getDistance (val) {
  let str = 0 + '米'
  if (val < 1000) {
    str = val + '米'
  } else if (val >= 1000) {
    str = (val / 1000).toFixed(2) + '千米'
  }
  return str
}

export function getVerType (data) {
  let str = ''
  switch (data) {
    case 1:
      str = '生产环境版'
      break
    case 2:
      str = '预发布版'
      break
    case 3:
      str = '内部测试版'
      break
    default:
      str = '--'
  }
  return str
}

export function getLimit (a) {
  let str = ''
  switch (a) {
    case 1:
      str = '50万以内'
      break
    case 2:
      str = '50~100万'
      break
    case 3:
      str = '100~200万'
      break
    case 4:
      str = '200~300万'
      break
    case 5:
      str = '300~500万'
      break
    case 6:
      str = '500~1000万'
      break
  }
  return str
}
// export function getMoneyDouble(val) {
//   let str = val
//   if (str != null) {
//     str = str + '.00'
//   } else {
//     str = '0.00'
//   }
//   return str
// }
export function getMoneyDouble(num) {
  const momey = num / 100
  let result = parseFloat(momey)
  if (isNaN(result)) {
    return '0.00'
  }
  result = Math.round(momey * 100) / 100
  let s_x = result.toString()
  let pos_decimal = s_x.indexOf('.')
  if (pos_decimal < 0) {
    pos_decimal = s_x.length
    s_x += '.'
  }
  while (s_x.length <= pos_decimal + 2) {
    s_x += '0'
  }
  return s_x
}



// WEBPACK FOOTER //
// ./src/filter/index.js